import moment from 'moment';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { bool, number, string } from 'prop-types';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
export const ALPHA_NUMERIC_NEW = 'alphaNumericNew';
export const BOOLEAN_REQUIRED = 'booleanRequired';
export const EMAIL_VALIDATOR = 'emailValidator';
export const CRYPTOPW_VALIDATOR = 'cryptoPWValidator';
export const CRYPTOPW_CONFIRM_VALIDATOR = 'cryptoPWConfirmValidator';
export const EMAIL_ALREADY_EXISTS_VALIDATOR = 'emailAlreadyExistsValidator';
export const TEXTAREA_VALIDATOR = 'textarea-validator';
export const USERNAME_VALIDATOR = 'username-validator';
export const REQUIRED_FILE_DESCRIPTION = 'required-file-description';
export const BIRTH_DATE_VALIDATOR = 'validate-birthday-by-tasy-param';
export const EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
export const TEXTAREA_REGEX = new RegExp(/^[A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ --0-9@//_.;:?º°]*$/gm);
const USERNAME_PREFIX_RESERVED = 'TWS-';
const USERNAME_MIN_LENGTH_VALIDATION = 6;
const USERNAME_MAX_LENGTH_VALIDATION = 50;
export function textareaValidator(value) {
    let valid = false;
    if (!value) {
        valid = true;
    }
    else if (String(value).replace(/\s+/gm, ' ').length === String(value).length) {
        valid = String(value).match(TEXTAREA_REGEX) != null;
    }
    return [{
            message: valid ? '' : 'patient.validator.textarea-message',
            name: TEXTAREA_VALIDATOR,
            valid,
        }];
}
const cryptoPwMessageParams = new Map([
    [
        'minMax', [
            { regex: '#@MIN_CARACTER#@', value: '1' },
            { regex: '#@MAX_CARACTER#@', value: '16' }
        ]
    ]
]);
const cryptoPwMessageItem = [
    { key: 'minMax', message: 'patient.validator.password-message-01' },
    { key: 'lengthNumber', message: 'patient.validator.password-message-02' },
    { key: 'caseSensitive', message: 'patient.validator.password-message-03' },
    { key: 'lengthSymbol', message: 'patient.validator.password-message-04' },
];
function getMessageAndReplaceParam(messageItem) {
    const message = MessageService.translate(messageItem.message);
    const messageParams = cryptoPwMessageParams.get(messageItem.key);
    if (messageParams != null && messageParams.length > 0) {
        let finalMessage = message;
        messageParams.forEach(param => {
            finalMessage = finalMessage.replace(param.regex, param.value);
        });
        return finalMessage;
    }
    return message;
}
export function booleanRequired(value) {
    const valid = Boolean(value);
    return [{
            message: valid ? '' : 'tws.validator.required',
            name: 'booleanRequired',
            valid,
        }];
}
export function emailValidator(value) {
    let valid = true;
    let message = '';
    if (value) {
        valid = !!value && Boolean(value.match(EMAIL));
        message = !valid ? 'patient.email-validator' : '';
    }
    return [{
            message,
            name: EMAIL_VALIDATOR,
            valid,
        }];
}
export function emailAlreadyExistsValidator(value) {
    value;
    const valid = false;
    return [{
            message: 'patient.create-user.email-already-activated',
            name: EMAIL_ALREADY_EXISTS_VALIDATOR,
            valid,
        }];
}
export function cryptoPWValidator(value) {
    const cryptopwRegex = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[\w\s])(?=.*?[-/*+_.,!?#$%&~|^@;:(){}]).{8,16}$/);
    const valid = cryptopwRegex.test(String(value || ''));
    return cryptoPwMessageItem.map(item => ({
        message: getMessageAndReplaceParam(item),
        name: CRYPTOPW_VALIDATOR,
        valid
    }));
}
export function cryptoPWConfirmValidator(value, { cryptoPW } = {}) {
    let valid = true;
    if (cryptoPW && value) {
        valid = cryptoPW === value;
    }
    return [{
            message: valid ? '' : 'newaccount.validator.password.not.match',
            name: CRYPTOPW_CONFIRM_VALIDATOR,
            valid
        }];
}
cryptoPWConfirmValidator.optionTypes = {
    cryptoPW: string,
};
export function birthdayValidator(value, { minAge = 0 } = {}) {
    const currentDate = moment().startOf('day');
    const minimumDate = currentDate.subtract(minAge, 'years');
    const birthDate = moment(value, 'YYYY-MM-DD', true).startOf('day');
    const isValid = birthDate.isBefore(minimumDate) || birthDate.isSame(minimumDate);
    const message = MessageService.translate('patient.birthdate.validation');
    const formattedMessage = message.replace('#@QT_ANOS#@', String(minAge));
    return [{
            message: (minAge === 0 || isValid) ? '' : formattedMessage,
            name: BIRTH_DATE_VALIDATOR,
            valid: (minAge === 0 || isValid)
        }];
}
birthdayValidator.optionTypes = {
    minAge: number,
};
export function usernameValidator(value) {
    const USERNAME_VALIDATOR_REGEX = new RegExp(/^[A-Za-z0-9]+[\w.]*$/);
    const minLengthValidator = ModelService.getValidator('min-length');
    const minLengthResult = minLengthValidator(value, { min: USERNAME_MIN_LENGTH_VALIDATION });
    const maxLengthValidator = ModelService.getValidator('max-length');
    const maxLengthResult = maxLengthValidator(value, { max: USERNAME_MAX_LENGTH_VALIDATION });
    const isValidUsernamePrefix = !value || !String(value).toLocaleUpperCase().startsWith(USERNAME_PREFIX_RESERVED);
    let isValidUsernameFormat = false;
    const username = String(value);
    if (USERNAME_VALIDATOR_REGEX.test(username)) {
        const validations = [
            !username.endsWith('.'),
            !username.endsWith('_'),
            !username.includes('..'),
            !username.includes('__'),
            !username.includes('._'),
            !username.includes('_.')
        ];
        isValidUsernameFormat = validations.every(validation => validation);
    }
    return [
        ...minLengthResult,
        ...maxLengthResult,
        {
            message: isValidUsernamePrefix ? '' : MessageService.translate('patient.validation-message.invalid-user'),
            name: 'validate-username-prefix',
            valid: isValidUsernamePrefix
        },
        {
            message: isValidUsernameFormat ? '' : MessageService.translate('patient.validation-message.alphanumeric'),
            name: USERNAME_VALIDATOR,
            valid: isValidUsernameFormat
        }
    ];
}
export function requiredFileDescriptionValidator(value) {
    const currentValue = value || [];
    const valid = currentValue.every(file => file.description);
    return [{
            message: 'file-uploader.required-files-description-validator',
            name: REQUIRED_FILE_DESCRIPTION,
            valid,
        }];
}
export function alphaNumericNew(value, { allowWhiteSpace = false } = {}) {
    const validation = {
        message: 'patient.alpha-numeric.validator',
        name: ALPHA_NUMERIC_NEW,
        valid: false,
    };
    if (!value) {
        validation.message = '';
        validation.valid = true;
        return [validation];
    }
    if (allowWhiteSpace) {
        value = value.replace(/\s/g, '');
    }
    const mask = /^[a-zA-Z0-9]*$/;
    validation.valid = Boolean(value?.length && value.match(mask));
    return [validation];
}
alphaNumericNew.optionTypes = {
    allowWhiteSpace: bool,
};
//# sourceMappingURL=validators.js.map